import {createContext, useState, useEffect, useContext, FC, useCallback, useMemo} from 'react';
import {AnyReceiveMethodName, ReceiveDataMap, VKBridgeEvent} from '@vkontakte/vk-bridge';
import {getCurrentHash, getCurrentSearch, getCurrentSearchParams} from './utils';
import {bridge} from './bridge';
// import {isDev} from './constants';

const SearchParamsContext = createContext<ReturnType<typeof getCurrentSearchParams> | undefined>(undefined);

type SearchParamsCreaterProps = {
    children?: React.ReactNode;
};

export const SearchParamsContextCreater: FC<SearchParamsCreaterProps> = ({children}) => {
    const [search, setSearch] = useState(getCurrentSearch());

    const appChangeFragment = useCallback(({detail: {data, type}}: VKBridgeEvent<AnyReceiveMethodName>) => {
        if (type === 'VKWebAppChangeFragment') {
            const newHash = getCurrentHash((data as ReceiveDataMap['VKWebAppChangeFragment']).location);

            if (newHash !== getCurrentHash()) {
                setSearch(getCurrentSearch(newHash));
            }
        }
    }, []);

    // эффект для отладки смены урла
    // useEffect(() => {
    //     if (isDev) {
    //         window.addEventListener('popstate', (e) => {
    //             setSearch(getCurrentSearch());
    //         });
    //     }
    // }, []);

    useEffect(() => {
        bridge && bridge.subscribe(appChangeFragment);

        return () => {
            bridge && bridge.unsubscribe(appChangeFragment);
        };
    }, [appChangeFragment]);

    const params = useMemo(() => getCurrentSearchParams(search), [search]);

    return (
        <SearchParamsContext.Provider
            value={params}
            children={children}
        />
    );
};

// используется до передачи в основные компоненты
export const useSearchBaseParams = () => {
    const context = useContext(SearchParamsContext);
    if (!context) {
        throw new Error('No SearchParamsContext.Provider found when calling useSearchParams.');
    }
    return context;
};

// используется после, делаем обязательным formDataHash
export const useSearchParams = () => {
    const params = useSearchBaseParams();

    const {formDataHash} = params;

    if (typeof formDataHash !== 'string') {
        throw new Error('Required parameter D not received to inner app');
    }

    return {...params, formDataHash};
};
